import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';
import logoImage from '../../../assets/reddickrednobackground.png'; // Assuming path

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="home-header">
      <div className="logo">
        <Link to="/">
          <img src={logoImage} alt="Reddicks Logo" className="brand-logo-img" />
          <span className="brand-name">REDDICKS</span>
        </Link>
      </div>
      
      <div className="header-right">
        <nav className={`main-nav ${mobileMenuOpen ? 'active' : ''}`}>
          <ul>
            <li><Link to="/tokenomics" className="nav-item" onClick={() => setMobileMenuOpen(false)}>Tokenomics</Link></li>
            <li><Link to="/buy" className="nav-item" onClick={() => setMobileMenuOpen(false)}>Buy</Link></li>
            <li><Link to="/game-info" className="nav-item" onClick={() => setMobileMenuOpen(false)}>Reddicks Games</Link></li>
            <li><Link to="/whyreddicks" className="nav-item" onClick={() => setMobileMenuOpen(false)}>Why Choose REDDICKS?</Link></li>
            <li><Link to="/stake" className="nav-item stake-link" onClick={() => setMobileMenuOpen(false)}>$DCKS Staking</Link></li>
            <li><Link to="/validator" className="nav-item" onClick={() => setMobileMenuOpen(false)}>$XRD Staking</Link></li>
            <li><Link to="/treasury" className="nav-item treasury-link" onClick={() => setMobileMenuOpen(false)}>Treasury</Link></li>
            <li><Link to="/charity" className="nav-item charity-link" onClick={() => setMobileMenuOpen(false)}>Charity</Link></li>
            <li className="dropdown-container" ref={dropdownRef}>
              <button 
                className="nav-item dropdown-toggle" 
                onClick={toggleDropdown}
                aria-expanded={dropdownOpen}
                aria-haspopup="true"
              >
                More <span className="dropdown-icon">{dropdownOpen ? '▲' : '▼'}</span>
              </button>
              <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
                <li><Link to="/memecollection" className="dropdown-item" onClick={() => {setDropdownOpen(false); setMobileMenuOpen(false);}}>Meme Collection</Link></li>
                <li><a href="https://wallet.radixdlt.com/" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => {setDropdownOpen(false); setMobileMenuOpen(false);}}>Download Radix Wallet</a></li>
              </ul>
            </li>
          </ul>
        </nav>
        
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <span className={`menu-bar ${mobileMenuOpen ? 'open' : ''}`}></span>
        </div>
      </div>
    </header>
  );
};

export default Header; 